var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
        'rounded-lg',
        _vm.isMain ? 'bg-indigo-600' : 'bg-gray-600',
        _vm.isMain ? 'hover:bg-indigo-500' : 'hover:bg-gray-500',
        'text-white',
        'px-4',
        'py-3',
        'focus:outline-none',
        _vm.disabled ? 'opacity-50 cursor-not-allowed' : null,
    ],attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":(e) => _vm.$emit('click', e)}},[(!_vm.disabled)?_c('span',[_vm._v(_vm._s(_vm.content))]):_vm._e(),_vm._v(" "),(_vm.disabled)?_c('span',[_vm._v(_vm._s(_vm.disabledContent || _vm.content))]):_vm._e(),_vm._v(" "),(!_vm.content)?_c('span',[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }